<template>
  <div class="blinkist-account">
    <div class="blinkist-account__element">
      <div class="blinkist-account__state">
        <span class="blinkist-account__label" v-html="`${$t('email')}:&nbsp;`" />
        <span class="blinkist-account__value">
          {{ email || $t("noEmail") }}
        </span>
      </div>

      <div>
        <a
          class="blinkist-account__link"
          data-test="showChangeEmailModal"
          v-if="account"
          @click="$emit('change-email')"
        >
          {{ $t("changeEmail") }}
        </a>
        <a class="blinkist-account__link" data-test="showAddLoginModal" v-if="!account" @click="$emit('add-login')">
          {{ $t("addLoginDetails") }}
        </a>
      </div>
    </div>

    <div class="blinkist-account__element">
      <div class="blinkist-account__state blinkist-account__password" v-if="account">
        <span class="blinkist-account__label" v-html="`${$t('password')}:&nbsp;`" />
        <span class="blinkist-account__value"> ******* </span>
      </div>

      <div v-if="account">
        <a class="blinkist-account__link" data-test="showChangePasswordModal" @click="$emit('change-password')">
          {{ $t("changePassword") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @emits change-password
 * @emits change-email
 * @emits add-login
 */
export default {
  name: "BlinkistAccount",
  props: {
    account: {
      type: Object,
      default: null
    }
  },
  computed: {
    email() {
      return this.account && this.account.email
    }
  },
  i18n: {
    messages: {
      en: {
        email: "Email",
        password: "Password",
        noEmail: "None added",
        changeEmail: "Change email address",
        addLoginDetails: "Link email login details",
        changePassword: "Change password"
      },
      de: {
        email: "Email",
        password: "Passwort",
        noEmail: "Nicht hinterlegt",
        changeEmail: "E-Mail-Adresse ändern",
        addLoginDetails: "E-Mail-Adresse hinzufügen",
        changePassword: "Password ändern"
      },
      es: {
        email: "Correo electrónico",
        password: "Contraseña",
        noEmail: "Ninguno agregado",
        changeEmail: "Cambiar dirección de correo electrónico",
        addLoginDetails: "Vincular detalles de inicio de sesión por correo electrónico",
        changePassword: "Cambiar contraseña"
      }
    }
  }
}
</script>

<style lang="scss">
.blinkist-account {
  @include font-style(p);

  &__element:not(:last-child) {
    margin-bottom: $spacing-32;
  }

  &__state {
    display: flex;
    flex-direction: column;
    margin-bottom: $spacing-8;

    @include media(min-width, m) {
      flex-direction: row;
      margin-bottom: 0;
    }
  }

  &__label,
  &__value {
    @include media(max-width, m) {
      display: block;
    }
  }

  &__label {
    @include font-style(h5, $color: $mid-grey);
  }

  &__link {
    cursor: pointer;
  }
}
</style>
